import type { CapabilitiesSnapshot } from '../../../entities/me/me-contract.types';
import { hasPermission } from '../../../shared/access/access';

/** Полный CRUD филиалов организации (tenant). */
export const PERM_BRANCHES_ORG_WRITE = 'branches:org_write' as const;
/** Карточка и ограниченные поля назначенного филиала. */
export const PERM_BRANCHES_PROFILE_WRITE = 'branches:profile_write' as const;

/**
 * Просмотр списка филиалов: `branches:org_write` или `branches:profile_write`.
 * На странице дополнительно требуется маршрут `/organization/branches` в `routes_allowed`.
 */
export function branchesTenantCanView(caps: CapabilitiesSnapshot | null | undefined): boolean {
  return hasPermission(caps, PERM_BRANCHES_ORG_WRITE) || hasPermission(caps, PERM_BRANCHES_PROFILE_WRITE);
}

/** Создание точки — только `branches:org_write` (не путать с правкой «своего» филиала у АФ). */
export function branchesTenantCanCreate(caps: CapabilitiesSnapshot | null | undefined): boolean {
  return hasPermission(caps, PERM_BRANCHES_ORG_WRITE);
}

/** Правка карточки (drawer): org или ограниченный profile scope. */
export function branchesTenantCanUpdate(caps: CapabilitiesSnapshot | null | undefined): boolean {
  return hasPermission(caps, PERM_BRANCHES_ORG_WRITE) || hasPermission(caps, PERM_BRANCHES_PROFILE_WRITE);
}

/** Отключение активной точки — только `branches:org_write`. */
export function branchesTenantCanDeactivate(caps: CapabilitiesSnapshot | null | undefined): boolean {
  return hasPermission(caps, PERM_BRANCHES_ORG_WRITE);
}
